import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import Link from 'next/link';
import {fontWeight} from '@styles/helpers';
import {OvalTheme} from '@models/OvalTheme';
import {memo} from 'react';

const OvalBtn = styled.button<{ small: boolean; theme: any }>`
  min-height: ${(props) => (props.small ? 25 : 50)}px;
  display: grid;
  place-content: center;
  padding: ${(props) => (props.small ? '10px 25px' : '10px 5vw')};
  background-color: ${(props) => (props.theme === 'red' ? colors.red : colors.mainTextColor)};
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: ${(props) => (props.small ? '12px' : '18px')};
  font-weight: ${fontWeight.semiBold};
  color: ${colors.white};
`;

interface OvalButtonProps {
  title: string;
  onClick?: any;
  className?: string;
  href?: string;
  small?: boolean;
  theme?: any;
}

const OvalButton = ({ title, onClick, className = '', href, small, theme = OvalTheme.DEFAULT }: OvalButtonProps) => {
  return (
    <>
      {href ? (
        <Link href={href}>
          <OvalBtn theme={theme} small={small} className={className}>
            {title}
          </OvalBtn>
        </Link>
      ) : (
        <OvalBtn theme={theme} small={small} className={className} onClick={onClick}>
          {title}
        </OvalBtn>
      )}
    </>
  );
};

export default memo(OvalButton);
